<mat-chip-listbox>
  <mat-chip-option *ngFor="let option of options"
                   [ngClass]="'badge-' + option.colorClass"
                   class="tab-chip"
                   routerLinkActive="active"
                   [aria-label]="option.label + ' link'"
                   [routerLink]="option.value"
                   queryParamsHandling="preserve"
  >
    <div class="flex flex-row justify-center items-center gap-2">
      <span [ngClass]="option.colorClass">{{ option.label | translate }}</span>
      <app-badge *ngIf="showCounts"
                 [color]="option.isActive ? option.colorClass : ThemePalette.NEUTRAL"
                 [number]="option.count" />
    </div>
  </mat-chip-option>
</mat-chip-listbox>
